<template>
<div id="it1024im" style="height: 100%;">
    <!-- 头部组件 -->
    <!-- <component :is="header_"></component> -->
    
    <div class="it1024im">
    <!--  -->
    <el-container class="el-container-box" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <!-- <component :is="celan"></component> -->
      

      <!-- 主体 -->
      <el-main>
      <div id="container">
        <div class="it1024im-header">
          <div>IM</div>
        </div>
        <div class="it1024im-section" style="background: #ebebeb;">
          <ul>
            <div v-for="(it1024im_,idx) in it1024im_id">
             <div v-for="number in userid_number">
                <div v-if="number.userid==it1024im_?true:false">
                     <li @click="GetUserid(it1024im_)">
                       <img :src="it1024imURL+'/php/upimg/it1024im-fangkeimg.png'">
                       <div class="it1024im-chat-list">
                         <p style="font-size: 17px;">访客 ({{it1024im_}})</p>
                         <p v-if="number.userid_number!='0'?false:true" style="font-size:13px;color:#999;">
                            &nbsp;已读
                         </p>                         
                         <p v-if="number.userid_number=='0'?false:true" style="font-size:13px;color:#999;">
                            &nbsp;未读
                         </p>
                       </div>
                         <span v-if="number.userid==it1024im_?true:false" class="it1024im-Unread-messages">
                           <span v-if="number.userid_number=='0'?false:true">
                             {{number.userid_number}}
                           </span>
                         </span>
                     </li> 
                </div>          
             </div>          
            </div>          
          </ul>

        </div>
        <div class="it1024im-footer">
            <!-- 底部导航 -->
            <ul class="footer-tab">
              <li>
               <router-link to='/mobile'>
                <i class="el-icon-chat-square"></i>
                <span>消息</span>
               </router-link>
              </li>
              <li>
               <router-link to='/setting'>
                <i class="el-icon-s-custom"></i>
                <span>我的</span>
               </router-link>
              </li>
            </ul>
        </div>
      </div>    
        
      </el-main>

    </el-container>
    </div>

</div>
</template>

<script>
//全局属性
import global from '@/common/common.vue'
//头部组件
import header_ from './header_.vue'    
import celan from './celan.vue'    
export default {
    name: 'it1024im',
    data() {
      return {
        header_: header_,
        celan: celan,
        textarea_val: '',
        it1024im:[],
        it1024im_id:[],
        userid_number:[],
        ImUserid:'',
        ChatList:[],
        it1024imURL: global.it1024imURL,
        posturl: global.it1024imUrl,
      };
    },
    methods: {
       GetUserid(id){
           localStorage.setItem("It1024imDataLengths",'');
           //点击设置已读
           localStorage.setItem("ImUserid",id); 
           this.ImUserid = id;
           this.$http.post(this.posturl,{userid:id,ReadId:id},{emulateJSON:true}).then(res=>{
               console.log("已读1");
               // this.it1024im=res.body;
           });
           //路由跳转
           this.$router.push({path:'/mobilechat'});

       }    
    },
    mounted() {
      localStorage.setItem("numberSum2",'');
      var ImUserid = localStorage.getItem("ImUserid"); 
      //请求数据
      setInterval(()=>{
          if(ImUserid != null){
            //获取所有聊天数据
            this.$http.post(this.posturl,{chatdata:ImUserid},{emulateJSON:true}).then(res=>{
               // this.it1024im=res.body;
               //把所有聊天数据存到本地存储
               localStorage.setItem("IT1024IM",JSON.stringify(res.body)); 
            });
           };  
           this.$http.post(this.posturl,{userid_:true},{emulateJSON:true}).then(res=>{
               // this.it1024im_id=res.body[0];
               // this.userid_number=res.body[1];
               //把userid和未读数量存到本地存储
               localStorage.setItem("it1024im_id",JSON.stringify(res.body[0])); 
               localStorage.setItem("userid_number",JSON.stringify(res.body[1])); 

           });
           //读取本地存储数据的userid和未读数量
           this.it1024im_id = JSON.parse(localStorage.getItem("it1024im_id"));
           this.userid_number = JSON.parse(localStorage.getItem("userid_number"));


           //收到信息提示声音
           var numberArr=this.userid_number;
           var numberSum=0;
           for (var key in numberArr) {
               if (numberArr[key].userid_number != '0') {
                  //未读总数
                  numberSum+=parseInt(numberArr[key].userid_number);
                  this.numberSum=parseInt(numberArr[key].userid_number);
               }
           };
           var numberSum2 = localStorage.getItem("numberSum2");
           if (numberSum > numberSum2) {
               var audio= new Audio(""+this.it1024imURL+"/assets/im.mp3");
               audio.play();
               localStorage.setItem("numberSum2",numberSum);
               // console.log("1");
           }else{
               // console.log("2");
               localStorage.setItem("numberSum2",numberSum);
           };


      },1000);
      //读取本地存储数据的userid和未读数量
      this.it1024im_id = JSON.parse(localStorage.getItem("it1024im_id"));
      this.userid_number = JSON.parse(localStorage.getItem("userid_number"));

    }
  }
</script>


<style scoped>
*{ 
  margin:0;
  padding: 0;
}
html,body {
    width: 100%;
    height: 100%;
}
ul{
    list-style-type: none
}
a:link{
  text-decoration: none;
}
.el-container-box,#it1024im,.it1024im {
    width: 100%;
    height: 100%;
}

/*@media screen and (max-width: 800px) {

}*/


.it1024im-chat-list{
    margin-left: 3.1rem;
}

.it1024im-Unread-messages {
    background: #ff4444;
    color: #fff;
    font-size: 12px;
    border-radius: 53%;
    width: 1.5rem;
    display: inline-block;
    text-align: center;
    overflow: hidden;
    float: right;
    margin-top: -2.5rem;
}
.it1024im-window-textarea{
      -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    height: 40px;
    padding-left: 5px;
    border: 0;
    background-color: #fff;
    border-radius: 3px;
}
.it1024im-window-button{
    border-radius: 3px;
    height: 40px;
    padding: 0 20px;
    border: 0;
    margin-left: 10px;
    background-color: #5FB878;
    color: #fff;
}




.it1024im-chat-footer {
    display: flex;
    justify-content: space-around;
    text-align: center;
    align-items: baseline;
}



.it1024im-section ul li {
    padding: 8px;
    background: #efefef;
    margin: 2px;
    border-radius: 3px;
    cursor: pointer;
}
.it1024im-section ul li img{
    vertical-align: middle;
    border-style: none;
    width: 38px;
    border-radius: 50%;
    float: left;
    margin-top: 0.2rem;
}
#container {
    display: flex;
    height: 100%;
    flex-direction: column;
}
.it1024im-header {
    background: #6793e0;
    width: 100%;
    z-index: 99;
    height: 3rem;
    line-height: 3rem;
    font-size: 1.3rem;
    padding-left: 0.5rem;
    color: white;
    font-weight: bold;
}
.it1024im-section {
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow: auto;
    -moz-overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.it1024im-footer {
    width: 100%;
    background: #ffffff;
    height: 3.6rem;
}
.it1024im-footer ul {
    display: flex;
    justify-content: space-around;
    text-align: center;
    align-items: baseline;
}

.footer-tab li{
    line-height: 19px;
    padding-top: 1px;
}
.footer-tab li:nth-child(1) i, .footer-tab li:nth-child(1) span{
    color: #6793e0;;
}
.footer-tab li:nth-child(2) i, .footer-tab li:nth-child(2) span{
    color: #7b7b7b;
}
.footer-tab span{
    display: block;
    font-size: 13px;
}
.footer-tab i{
    font-size: 1.6rem;
}



</style>


// WEBPACK FOOTER //
// src/components/mobile.vue